import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,
	TextField, Typography } from "@mui/material";
import { FC, useState } from "react";

interface Props {
	open: boolean;
	onClose: () => void;
	onConfirm: (reason: string) => Promise<void>;
}

const EpiCancelInspectionModal: FC<Props> = ({ open, onClose, onConfirm }) => {
	const [reason, setReason] = useState('');
	const [loading, setLoading] = useState(false);

	return (
		<Dialog
			open={open}
			onClose={() => close()}
			id="modal-cancel-epi-inspection"
		>
			<DialogTitle>Cancelar inspeção</DialogTitle>
			<DialogContent id="modal-cancel-epi-inspection-content">
				<Typography>
					Você confirma o cancelamento desta inspeção? O rascunho preenchido será descartado.
				</Typography>
				<TextField
					required
					label="Motivo do cancelamento"
					size="small"
					fullWidth
					multiline
					minRows={2}
					sx={{ marginTop: "1vh" }}
					value={reason}
					onChange={(e) => setReason(e.target.value)}
				/>
			</DialogContent>
			<DialogActions>
				<Button id="cancel-epi-inspection-close-button" onClick={() => close()}>
					Voltar
				</Button>
				<Button
					id="cancel-epi-inspection-confirm-button"
					color="error"
					variant="contained"
					disabled={loading || !reason.trim()}
					onClick={() => confirm()}
				>
					{loading
						? <CircularProgress sx={{color: "#48a7dbff"}} size={'20px'}/>
						: "Cancelar inspeção"
					}
				</Button>
			</DialogActions>
		</Dialog>
	);

	function close() {
		if (loading) {
			return;
		}
		setReason('');
		onClose();
	}

	async function confirm() {
		setLoading(true);
		await onConfirm(reason);
		setLoading(false);
		setReason('');
	}
};

export default EpiCancelInspectionModal;
